import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope, EnvelopeDraft } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const getSignatureDraft = (
  constructGet: ConstructGet,
  envelope: Envelope,
  draftId: string,
): Promise<NonPaginatedResponse<EnvelopeDraft> | undefined> =>
  constructGet<NonPaginatedResponse<EnvelopeDraft>>(
    `${SIGNATURE_BASE_PATH}/envelope/${envelope.id}/drafts/${draftId}`,
    undefined,
    { transformerSet: TransformerSet.PreserveKeys },
  );
